import React, { useState, useEffect } from "react";
import InputMask from "react-input-mask";
import usePostData from "../../../../repo/post";
import Switch from "react-switch";

const CardRegistratos = () => {
  const [cargo, setCargo] = useState("");
  const [nome, setNome] = useState("");
  const [email, setEmail] = useState("");
  const [cpf, setCpf] = useState("");
  const [telefone, setTelefone] = useState("");
  const [senha, setSenha] = useState("");
  const [endereco, setEndereco] = useState("");
  const [cidade, setCidade] = useState("");
  const [bairro, setBairro] = useState("");
  const [cep, setCep] = useState("");
  const [switchChecked, setSwitchChecked] = useState(false);
  const [showEndereco, setShowEndereco] = useState(false);
  const [showSwitch, setShowSwitch] = useState(false);
  const [error, setError] = useState(null);

  const { postData } = usePostData();

  // Ajusta visibilidade de campos e senha quando cargo muda
  const handleCargoChange = (e) => {
    const selected = e.target.value;
    setCargo(selected);
    setShowEndereco(selected === "ENTREGADOR");
    setShowSwitch(selected === "MOTORISTA");
    if (selected === "ENTREGADOR") {
      setSenha(email || "");
    }
  };

  // Mantém senha = email se for ENTREGADOR
  useEffect(() => {
    if (cargo === "ENTREGADOR") {
      setSenha(email);
    } else {
      setSenha("");
    }
  }, [email, cargo]);

  const handleSwitchChange = (checked) => {
    setSwitchChecked(checked);
  };

  const handleSave = async () => {
    setError(null);
    if (!nome || !email || !cpf || !telefone || (cargo !== "ENTREGADOR" && !senha)) {
      setError("Por favor, preencha todos os campos obrigatórios.");
      return;
    }
    if (cargo === "ENTREGADOR" && (!endereco || !cidade || !bairro || !cep)) {
      setError("Preencha todos os campos de endereço para entregadores.");
      return;
    }

    const payload = {
      nome,
      email,
      telefone: telefone.replace(/\D/g, ""),
      cpf: cpf.replace(/\D/g, ""),
      senha: cargo === "ENTREGADOR" ? email : senha,
      base: [localStorage.getItem("baseSelected")],
      role: cargo || "FUNCIONARIO",
      endereco: null,
    };
    if (cargo === "ENTREGADOR") {
      payload.endereco = `${endereco}, ${bairro}, ${cidade} - ${cep}`;
    }
    if (cargo === "MOTORISTA") {
      payload.frete = switchChecked;
    }

    try {
      const response = await postData("auth/register", payload);
      if (response?.id) {
        alert("Cadastro realizado com sucesso!");
        // reset campos
        setNome(""); setEmail(""); setCpf(""); setTelefone(""); setSenha("");
        setCargo(""); setEndereco(""); setCidade(""); setBairro(""); setCep("");
        setSwitchChecked(false); setShowEndereco(false); setShowSwitch(false); setError(null);
      } else {
        setError(response.message || "Erro ao cadastrar.");
      }
    } catch (err) {
      console.error(err);
      setError("Erro ao cadastrar.");
    }
  };

  return (
    <>
      <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-100 border-0">
        <div className="rounded-t bg-white mb-0 px-6 py-6">
          <div className="text-center flex justify-between">
            <h6 className="text-blueGray-700 text-xl uppercase font-bold">Cadastros dos Colaboradores</h6>
            {error && <p className="text-red-500">{error}</p>}
            <div className="flex flex-col md:flex-row items-center justify-between">
              <button
                onClick={handleSave}
                className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-sm px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none ease-linear transition-all duration-150"
                type="button"
              >
                <i className="fas fa-save mr-2"></i>
                CADASTRAR
              </button>
            </div>
          </div>
        </div>
        <div className="flex-auto px-4 lg:px-10 py-10 pt-0">
          <form>
            <h6 className="text-blueGray-400 text-sm mt-3 mb-6 font-bold uppercase">
              INFORMAÇÕES PESSOAIS
            </h6>
            <div className="flex flex-wrap">
              <div className="w-full lg:w-6/12 px-4">
                <div className="relative w-full mb-3">
                  <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="nome">
                    Nome completo
                  </label>
                  <input
                    type="text"
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    placeholder="Nome completo"
                    value={nome}
                    onChange={e => setNome(e.target.value)}
                  />
                </div>
              </div>
              <div className="w-full lg:w-6/12 px-4">
                <div className="relative w-full mb-3">
                  <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="email">
                    Email
                  </label>
                  <input
                    type="email"
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    placeholder="exemplo@dominio.com"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                  />
                </div>
              </div>
              <div className="w-full lg:w-4/12 px-4">
                <div className="relative w-full mb-3">
                  <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="cpf">
                    CPF
                  </label>
                  <InputMask
                    mask="999.999.999-99"
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    placeholder="000.000.000-00"
                    value={cpf}
                    onChange={e => setCpf(e.target.value)}
                  >
                    {inputProps => <input {...inputProps} type="text" />}
                  </InputMask>
                </div>
              </div>
              <div className="w-full lg:w-4/12 px-4">
                <div className="relative w-full mb-3">
                  <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="telefone">
                    Telefone
                  </label>
                  <InputMask
                    mask="(99)99999-9999"
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    placeholder="(75)99999-9999"
                    value={telefone}
                    onChange={e => setTelefone(e.target.value)}
                  >
                    {inputProps => <input {...inputProps} type="text" />}
                  </InputMask>
                </div>
              </div>
              {/* Senha oculta se ENTREGADOR */}
              {cargo !== "ENTREGADOR" && (
                <div className="w-full lg:w-4/12 px-4">
                  <div className="relative w-full mb-3">
                    <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="senha">
                      Senha
                    </label>
                    <input
                      type="password"
                      className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      placeholder="Senha"
                      value={senha}
                      onChange={e => setSenha(e.target.value)}
                    />
                  </div>
                </div>
              )}
              <div className="w-full lg:w-4/12 px-4">
                <div className="relative w-full mb-3">
                  <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="cargo">
                    Cargo
                  </label>
                  <select
                    value={cargo}
                    onChange={handleCargoChange}
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  >
                    <option value="">Selecione...</option>
                    <option value="FUNCIONARIO">FUNCIONARIO</option>
                    <option value="ENTREGADOR">ENTREGADOR</option>
                    <option value="MOTORISTA">MOTORISTA</option>
                    <option value="GERENTE">GERENTE</option>
                    <option value="SAC">SAC</option>
                    <option value="RH">RH</option>
                    <option value="ADMIN">ADMIN</option>
                  </select>
                </div>
              </div>

              {/* Switch MOTORISTA */}
              {showSwitch && (
                <div className="w-full px-4">
                  <label className="flex items-center gap-2">
                    <Switch
                      onChange={handleSwitchChange}
                      checked={switchChecked}
                      onColor="#86d3ff"
                      onHandleColor="#2693e6"
                      handleDiameter={30}
                      uncheckedIcon={false}
                      checkedIcon={false}
                      boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                      activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      height={20}
                      width={48}
                      className="react-switch"
                      id="material-switch"
                    />
                    <span className="text-2xl font-bold">Selecione esta opção para motoristas terceiros.</span>
                  </label>
                </div>
              )}

              {/* Endereço ENTREGADOR */}
              {showEndereco && (
                <>
                  <div className="w-full px-4">
                    <hr className="mt-6 border-b-1 border-blueGray-300" />
                    <h6 className="text-blueGray-400 text-sm mt-3 mb-6 font-bold uppercase">
                      Endereço do Entregador
                    </h6>
                  </div>
                  <div className="w-full lg:w-12/12 px-4">
                    <div className="relative w-full mb-3">
                      <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="endereco">
                        Endereço
                      </label>
                      <input
                        type="text"
                        className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        placeholder="Rua dos bobos, 0"
                        value={endereco}
                        onChange={e => setEndereco(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="w-full lg:w-6/12 px-4">
                    <div className="relative w-full mb-3">
                      <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="cidade">
                        Cidade
                      </label>
                      <input
                        type="text"
                        className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        placeholder="Ex.: Salvador"
                        value={cidade}
                        onChange={e => setCidade(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="w-full lg:w-6/12 px-4">
                    <div className="relative w-full mb-3">
                      <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="bairro">
                        Bairro
                      </label>
                      <input
                        type="text"
                        className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        placeholder="Bairro exemplo"
                        value={bairro}
                        onChange={e => setBairro(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="w-full lg:w-6/12 px-4">
                    <div className="relative w-full mb-3">
                      <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="cep">
                        CEP
                      </label>
                      <InputMask
                        mask="99999-999"
                        className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        placeholder="Ex.: 40000-000"
                        value={cep}
                        onChange={e => setCep(e.target.value)}
                      >
                        {inputProps => <input {...inputProps} type="text" />}
                      </InputMask>
                    </div>
                  </div>
                </>
              )}
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default CardRegistratos;
